export default __webpack_public_path__ + "static/media/how can we help.756900a1.jpg";